<template>
  <span class="release-category-tag">
    <span
      class="_dot"
      :style="{ backgroundColor: dotColor }"
    />
    <span class="_label">{{ label }}</span>
  </span>
</template>

<script setup>
import { computed } from 'vue';
import { releaseCategoryDotColor, releaseCategoryLabel } from '@/release-notes/release-categories';

const props = defineProps({
  category: {
    type: String,
    required: true,
  },
});

const label = computed(() => releaseCategoryLabel(props.category));
const dotColor = computed(() => releaseCategoryDotColor(props.category));
</script>

<style scoped lang="scss" type="text/scss">
  .release-category-tag {
    display: inline-flex;
    gap: .6rem;
    align-items: center;
    height: 2.5rem;
    padding: 0 .8rem;
    vertical-align: baseline;
    background-color: map_get($grey, 'lighten-8');
    background-clip: padding-box;
    border: 1px solid $border-color-dark;
    border-radius: 1.25rem;

    ._dot {
      flex-shrink: 0;
      width: .9rem;
      height: .9rem;
      border-radius: 50%;
    }

    ._label {
      margin-top: -.1rem;
      font-size: $font-size-3;
      font-weight: $font-weight-medium;
    }
  }
</style>
